import { VStack } from "@chakra-ui/react";

import NotAvailableCell from "@/common/components/NotAvailableCell";
import { LinearCleanupIssueLink } from "@/feature/components/LinearCleanupIssueLink";
import {
  PullRequestLink,
  PullRequestStatusBadge,
} from "@/feature/components/PullRequestLink";
import { FlagHeaderDTO } from "@reflag/shared/flagAPI";

export function FlagCleanupCell({
  linearCleanupIssue,
  cleanupPullRequest,
}: Pick<FlagHeaderDTO, "linearCleanupIssue" | "cleanupPullRequest">) {
  if (!linearCleanupIssue && !cleanupPullRequest) return <NotAvailableCell />;
  return (
    <VStack
      align="start"
      spacing={2}
      onClick={(event) => event.stopPropagation()}
    >
      {linearCleanupIssue && (
        <LinearCleanupIssueLink
          url={linearCleanupIssue.url}
          issue={linearCleanupIssue.details}
          fontSize="sm"
        />
      )}
      {cleanupPullRequest &&
        (cleanupPullRequest.url ? (
          <PullRequestLink
            url={cleanupPullRequest.url}
            number={cleanupPullRequest.number ?? undefined}
            title={
              cleanupPullRequest.number == null ? "Pull request" : undefined
            }
            status={cleanupPullRequest.status}
          />
        ) : (
          <PullRequestStatusBadge status={cleanupPullRequest.status} />
        ))}
    </VStack>
  );
}
